import { MapPinIcon } from '@/ui/map-pin-icon';
import classes from './port-symbol.module.css';

/**
 * @param {object} props
 * @param {boolean} [props.isCurrent]
 * @param {boolean} [props.isStart]
 * @param {boolean} [props.isOvernight]
 * @param {React.CSSProperties} [props.style]
 * @returns {React.JSX.Element}
 */
export function PortSymbol({ isCurrent, isStart, isOvernight }) {
  return isCurrent ? (
    <svg
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      style={{ filter: 'drop-shadow(0 4px 4px rgba(0, 0, 0, 0.53))' }}
    >
      <circle cx="12" cy="12" r="12" fill="var(--viking-medium-black)" />
      <circle cx="12" cy="12" r="8.5" stroke="var(--viking-lightest-gray)" strokeWidth="7" />
    </svg>
  ) : isStart ? (
    <MapPinIcon className={classes.pin} />
  ) : (
    <svg
      className={`${classes.port} ${isOvernight ? classes.portOvernight : ''}`}
      width="15.238"
      height="15.238"
      fill="none"
      viewBox="0 0 20 20"
    >
      <circle cx="10" cy="10" r="9" strokeWidth="2" />
    </svg>
  );
}
